<template>
  <div class="box_btoom_conten">
    <div class="boex_bottom_top">
      <div class="box_btoom">
        <p>联系我们</p>
        <div class="box_dianhua">
          <svg-icon iconClass="dianhua-2"
                    className="dianhua"></svg-icon>
          <span style="padding-left: 10px">86 - 755 - 25607666 25509955</span>
        </div>
        <div class="box_dianhua">
          <svg-icon iconClass="dizhi"
                    className="dianhua"></svg-icon>
          <span style="padding-left: 10px">深圳市罗湖区翠竹北路石化工业区1栋1-4楼</span>
        </div>
      </div>
      <div>
        <div class="box_weixin">
          微信公众号
        </div>
        <div class="box_weixin_img">
          <img src="../../Img/detaile/二维码.png"
               alt="" />
        </div>
      </div>
    </div>
    <div class="footer-copy">
      <p>
        Copyright © 2018-2020 周六福 All rights reserved.
        <a href="http://beian.miit.gov.cn/"
           target="_blank"
           style="color:white;">粤ICP备13087551号</a>

      </p>
      <div style="width:300px;margin:0 auto; padding:20px 0;">
        <a target="_blank"
           href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030302001449"
           style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="../..//Img/record.png"
               style="float:left;" />
          <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">
            粤公网安备 44030302001449号
          </p>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>

<style scope>
.box_weixin_img {
  width: 120px;
  height: 120px;
  padding-left: 22px;
  margin-top: 18px;
}
.box_weixin {
  padding-top: 44px;
  padding-left: 22px;
  font-size: 24px;
  color: #fff;
}
.box_dianhua {
  font-size: 16px;
  margin-top: 24px;
  color: #999;
}
.dianhua {
  width: 20px;
  height: 20px;
}
.box_btoom {
  padding-top: 44px;
  padding-left: 22px;
  font-size: 24px;
  color: #fff;
}
.boex_bottom_top {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  padding-bottom: 30px;
}
.box_btoom_conten {
  width: 100%;
  height: 400px;
  background-color: #212529;
  margin-top: 84px;
}
.footer-copy {
  padding: 50px 0 0 0;
  /* background: #333333; */
  border-top: 1px solid #5c5c5c;
  text-align: center;
}
.footer-copy > p {
  color: #7e7e7e;
  font-size: 14px;
  margin: 0;
  width: 100%;
  text-align: center;
  /* margin-top: 80px; */
}
.footer-copy p a {
  color: #007bff;
  text-decoration: none;
  background-color: transparent;
  -webkit-text-decoration-skip: objects;
}
</style>
